export const FareCalculator = (distance, time, rateDetails, instructionData, decimal) => {
    try {
        const parseNum = (val) => { let res = parseFloat(val); return isNaN(res) ? 0 : res; };
        let baseCalculated = (parseNum(rateDetails?rateDetails.rate_per_unit_distance:0) * parseNum(distance)) + (parseNum(rateDetails?rateDetails.rate_per_hour:0) * (parseNum(time) / 3600));
        
        if (rateDetails && rateDetails.base_fare > 0) baseCalculated += parseNum(rateDetails.base_fare);
        if (instructionData && instructionData.parcelTypeSelected) baseCalculated += parseNum(instructionData.parcelTypeSelected.amount);
        if (instructionData && instructionData.optionSelected) baseCalculated += parseNum(instructionData.optionSelected.amount);
        
        let minFare = rateDetails ? parseNum(rateDetails.min_fare) : 0;
        let total = baseCalculated > minFare ? baseCalculated : minFare;
        
        let convenienceFee = 0;
        if (rateDetails && rateDetails.convenience_fee_type === 'flat') { 
            convenienceFee = parseNum(rateDetails.convenience_fees); 
        } else if (rateDetails) { 
            convenienceFee = (total * parseNum(rateDetails.convenience_fees) / 100); 
        }
        
        let grand = total + convenienceFee;
        let dec = (typeof decimal === 'number') ? decimal : 2;
        
        return {
            totalCost: parseNum(Number(total).toFixed(dec)),
            grandTotal: parseNum(Number(grand).toFixed(dec)),
            convenience_fees: parseNum(Number(convenienceFee).toFixed(dec))
        };
    } catch (e) {
        return { totalCost: 0, grandTotal: 0, convenience_fees: 0 };
    }
};
